var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('currency-input',{staticClass:"wintouch-field-input",attrs:{"disabled":_vm.item.readOnly,"locale":"en-US","currency":"USD"},on:{"blur":_vm.handleBlur},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }